import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';

@Directive({
    selector: '[ifSuperAdmin]'
})
export class IfSuperAdminDirective {
    constructor(
        private readonly userService: LoggedInUserService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {
        if (this.userService.isSuperAdmin()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
